import { CHIP_COLORS } from '../../../../../../../constants/other'
import { lightGrey } from '../../../../../../../styles/const/colors'

export const formatPixelItems = items => {
  if (items && items.length) {
    return items.map(item => {
      const isItemActive = item.status !== 'No recent activity'

      return {
        value: item.id,
        label: item.name,
        tag: isItemActive ? 'Active' : 'Inactive',
        tagColor: {
          color: isItemActive ? CHIP_COLORS.success : CHIP_COLORS.neutral,
          shade: 'light'
        },
        labelColor: !isItemActive && lightGrey
      }
    })
  } else {
    return []
  }
}
